module.exports = __webpack_public_path__ + "img/mb-advantage-4.b93c9afa.png";